(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sc-reassurance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-delivery-dates')) {
  const dayMs = 86400000;
  const paris = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  const monthLong = new Intl.DateTimeFormat('fr-FR', { month: 'long', timeZone: 'UTC' });
  const dateShort = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', timeZone: 'UTC' });
  const dateYear = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });

  function todayInParis(now) {
    const parts = Object.fromEntries(paris.formatToParts(new Date(now))
      .filter(part => part.type === 'year' || part.type === 'month' || part.type === 'day')
      .map(part => [part.type, part.value]));
    return parts.year + '-' + parts.month + '-' + parts.day;
  }

  function asUTC(iso) {
    return new Date(iso + 'T12:00:00Z');
  }

  function shiftDay(iso, days) {
    return new Date(asUTC(iso).getTime() + days * dayMs).toISOString().slice(0, 10);
  }

  function dateRangeText(first, last) {
    if (first === last) return 'Livraison estimée le ' + dateShort.format(asUTC(first));
    if (first.slice(0, 4) !== last.slice(0, 4)) {
      return 'Livraison estimée du ' + dateYear.format(asUTC(first)) +
        ' au ' + dateYear.format(asUTC(last));
    }
    if (first.slice(0, 7) === last.slice(0, 7)) {
      return 'Livraison estimée du ' + Number(first.slice(8)) +
        ' au ' + Number(last.slice(8)) + ' ' + monthLong.format(asUTC(last));
    }
    return 'Livraison estimée du ' + dateShort.format(asUTC(first)) +
      ' au ' + dateShort.format(asUTC(last));
  }

  function untilNextParisDate(now) {
    const startDate = todayInParis(now);
    let before = now;
    let after = now + 37 * 3600000;
    while (after - before > 1000) {
      const halfway = Math.floor((before + after) / 2);
      if (todayInParis(halfway) === startDate) before = halfway;
      else after = halfway;
    }
    return Math.max(1000, after - now + 250);
  }

  customElements.define('sc-delivery-dates', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      window.addEventListener('pageshow', () => this.refresh(), { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) clearTimeout(this.timer);
        else this.refresh();
      }, { signal });
      this.refresh();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }

    refresh() {
      if (!this.isConnected) return;
      clearTimeout(this.timer);
      const min = Number(this.dataset.minDays);
      const max = Number(this.dataset.maxDays);
      if (!Number.isInteger(min) || !Number.isInteger(max) || min < 1 || max < min || max > 180) return;

      const now = Date.now();
      const today = todayInParis(now);
      const first = shiftDay(today, min);
      const last = shiftDay(today, max);
      this.textContent = dateRangeText(first, last);
      this.dataset.firstDate = first;
      this.dataset.lastDate = last;
      if (!document.hidden) this.timer = setTimeout(() => this.refresh(), untilNextParisDate(now));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
